import { message } from 'antd'
import StringInput from './StringInput'
import DateRangeInput from './DateRangeInput'
import SelectInput from './SelectInput'
import RadioInput from './RadioInput'
import SwitchInput from './SwitchInput'
import NumericInput from './NumericInput'
import SelectOrCreateInput from './SelectOrCreateInput'
import TimePeriod from './TimePeriod'
import DateTimeInput from './DateTimeInput'

export default SequencedFormInput = ({ formItemType, callbacks, props... }) ->

  { setError } = callbacks

  switch
    when formItemType is 'string'
      <StringInput { props... } />
    when formItemType is 'number'
      <NumericInput { props... } />
    when formItemType is 'dateRange'
      <DateRangeInput { props... } />
    when formItemType is 'timePeriod'
      <TimePeriod { props... } />
    when formItemType is 'select'
      <SelectInput { props... } />
    when formItemType is 'radio'
      <RadioInput { props... } />
    when formItemType is 'switch'
      <SwitchInput { props... } />
    when formItemType is 'selectOrCreate'
      <SelectOrCreateInput { props... } />
     when formItemType is 'dateTime'
      <DateTimeInput { props... } />
    else
      setError("Invalid type #{ formItemType } in configuration")
      <div />
